<template>
  <aside class="cart-page__aside">
    <h6>
      {{ ordering ? "К оплате" : "Детали заказа" }}
    </h6>
    <ul class="cart-page__aside-info">
      <li v-show="cartItems.length">
        <span>{{ cartItems.length | plural("товар", "товара", "товаров") }}</span>
        <span>{{ totalPriceWithoutDiscount }} ₽</span>
      </li>
      <li v-show="totalSale">
        <span>Скидка</span>
        <span>-{{ totalSale }} ₽</span>
      </li>
      <!--      <li>-->
      <!--        <span>Доставка</span>-->
      <!--        <span>0 ₽</span>-->
      <!--      </li>-->
    </ul>
    <div class="cart-page__aside-sum">
      <h6>Итого</h6>
      <h6>{{ totalPrice }} ₽</h6>
    </div>

    <template v-if="ordering">
      <button @click="$emit('order-create')" class="btn btn--black cart-page__aside-action">
        <IconComponent v-if="loading" name="loading" />
        <span v-else> Оформить заказ </span>
      </button>
      <div class="cart-page__aside-politic">
        <span>
          Нажимая на кнопку, вы соглашаетесь с
          <router-link :to="{ name: 'about', params: { link: 'termsOfUse' } }">
            условиями использования
          </router-link>
          и
          <router-link :to="{ name: 'about', params: { link: 'publicOffer' } }">
            публичной офертой
          </router-link>
        </span>
      </div>
    </template>
    <template v-else>
      <button
        :disabled="!cartItems.length"
        class="btn btn--black cart-page__aside-action"
        @click="toOrdering"
      >
        <span> Оформить заказ </span>
      </button>
      <!--      <div class="cart-page__aside-line"></div>-->

      <!--      <div class="cart-page__aside-footer">-->
      <!--        <span>-->
      <!--          До бесплатной доставки нужно <br />-->
      <!--          добавить товар на сумму:-->
      <!--        </span>-->
      <!--        <span> 3300 ₽ </span>-->
      <!--      </div>-->
    </template>
  </aside>
</template>

<script>
import authorizationModal from "components/modal/components/AuthorizationModal.vue";
import IconComponent from "components/IconComponent.vue";

export default {
  name: "CartAsideComponent",
  components: { IconComponent },
  props: {
    ordering: {
      type: Boolean,
    },
    loading: Boolean,
  },
  methods: {
    toOrdering() {
      if (this.isRegistered) {
        // Тут должен быть какой-то запрос который будет делать оплату после того как пользователь нажал на кнопку оформить заказ
        this.$emit("toOrdering", !this.ordering);
      } else {
        this.$store.state._modals.push({
          component: authorizationModal,
        });
      }
    },
  },
  computed: {
    activeCartItems() {
      return this.$store.state.auth.activeCartItems;
    },
    totalPrice() {
      return this.$store.state.auth.cart.reduce((sum, item) => {
        return item.product.price_retail * item.quantity + sum;
      }, 0);
    },
    totalPriceWithoutDiscount() {
      return this.$store.state.auth.cart.reduce((sum, item) => {
        return (
          (item.product && item.product.price_without_discount
            ? item.product.price_without_discount
            : item.product.price_retail) *
            item.quantity +
          sum
        );
      }, 0);
    },
    totalSale() {
      return this.totalPriceWithoutDiscount - this.totalPrice;
    },
    isRegistered() {
      return this.$store.state.auth.user ? this.$store.state.auth.user.email : false;
    },
    cartItems() {
      return this.$store.state.auth.cart;
    },
  },
};
</script>

<style lang="stylus">
.cart-page {

  &__aside {
    display flex
    flex-direction column
    gap 30px
    padding 30px
    background var(--white)
    border 2px solid var(--gray)
    border-radius 20px
    width 100%
    height fit-content

    h6 {
      font-weight: 600;
      font-size: 1.250rem
      line-height: 160%;
      text-transform none
    }
  }

  &__aside-info {
    display flex
    flex-direction column
    gap 15px

    li {
      display flex
      justify-content space-between

      span {
        font-weight: 400;
        font-size: 1rem
      }
    }
  }

  &__aside-sum {
    display flex
    justify-content space-between

    h6:nth-child(2) {
      font-weight 500
    }
  }

  &__aside-action {
    height 58px
    font-size: 1.250em
    line-height: 24px;
  }

  &__aside-politic {
    font-weight: 400;
    font-size: 0.750em
    line-height: 14px;
    color: var(--gray-7)

    & a {
      text-decoration underline
    }
  }

  &__aside-line {
    height 1px
    background var(--black-3)
  }

  &__aside-footer {
    display flex
    justify-content space-between
    align-items flex-end
    font-weight 400


    span:nth-child(1) {
      font-weight: 600;
      font-size: 1rem
    }
  }

}
</style>
